import React, { useState } from 'react';
import withSubmitButtons from 'Components/Admin/Form/components/WithSubmitButtons/withSubmitButtons';

import CrossLargeSVG from 'Components/Admin/assets/CrossLargeSVG';
import Input from 'Components/Input';

const TextArea = withSubmitButtons(Input);

const PdfEditor = (props) => {
  const [isHelpMenu, setIsHelpMenu] = useState(false);

  const handleOpenHelpMenu = () => setIsHelpMenu(true);
  const handleCloseHelpMenu = () => setIsHelpMenu(false);

  return (
    <div className="pdf-field">
      <TextArea
        variant="textarea"
        className="pdf-field__textarea"
        onClose={handleCloseHelpMenu}
        buttons={[
          <button className="pdf-field__help-btn" onClick={handleOpenHelpMenu} data-testid="formatting-help-btn">
            Formatting help
          </button>,
        ]}
        {...props}
      />
      {
        isHelpMenu && (
          <div className="help-menu" data-testid="formatting-help">
            <div className="help-menu__head">
              <span className="help-menu__head__title">Formatting help</span>
              <button
                className="help-menu__head__close-btn"
                onClick={handleCloseHelpMenu}
              >
                <CrossLargeSVG />
              </button>
            </div>
            <div className="help-menu__body">
              <div className="help-menu__body__block">
                <p className="help-menu__body__block__title">
                  SolidERP uses Markdown for formatting PDF. Here are the basics.
                </p>
                <div className="help-menu__body__block__row">
                  <div className="help-menu__body__block__left-column">
                    <p className="help-menu__body__block__left-column__title">Character formatting</p>
                    <p className="help-menu__body__block__left-column__description">**Strong**</p>
                    <p className="help-menu__body__block__left-column__description">*Emphasis*</p>
                    <p className="help-menu__body__block__left-column__description">***Strong&empasis***</p>
                    <p className="help-menu__body__block__left-column__description">--Strikethrough--</p>
                    <p className="help-menu__body__block__left-column__description">-Underlined-</p>
                  </div>
                  <div className="help-menu__body__block__right-column">
                    <div className="help-menu__body__block__right-column__formatting" />
                    <p className="strong">Strong</p>
                    <p className="emphasis">Emphasis</p>
                    <p className="strong emphasis">Strong&empasis</p>
                    <p className="strikethrough">Strikethrough</p>
                    <p className="underlined">Underlined</p>
                  </div>
                </div>
              </div>
              <div className="help-menu__body__block">
                <div className="help-menu__body__block__row">
                  <div className="help-menu__body__block__left-column">
                    <p className="help-menu__body__block__left-column__title">Headings</p>
                    <p className="help-menu__body__block__left-column__description"># First level</p>
                    <p className="help-menu__body__block__left-column__description">## Second level</p>
                    <p className="help-menu__body__block__left-column__description">### Third level</p>
                  </div>
                  <div className="help-menu__body__block__right-column">
                    <div className="help-menu__body__block__right-column__headings" />
                    <p className="first-level">First level</p>
                    <p className="second-level">Second level</p>
                    <p className="third-level">Third level</p>
                  </div>
                </div>
              </div>
              <div className="help-menu__body__block">
                <div className="help-menu__body__block__row">
                  <div className="help-menu__body__block__left-column">
                    <p className="help-menu__body__block__left-column__title">Lists</p>
                    <p className="help-menu__body__block__left-column__description">* bulleted</p>
                    <p className="help-menu__body__block__left-column__description">1. numbered</p>
                  </div>
                  <div className="help-menu__body__block__right-column">
                    <div className="help-menu__body__block__right-column__formatting" />
                    <p className="">• bulleted</p>
                    <p className="">1. numbered </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default PdfEditor;
